<script setup lang="ts">
import { usePersianDigits } from "~/composables/local/perisan-digits"

const props = defineProps<{
	value: number
	page: number
}>()

const digit = usePersianDigits(() => props.value)
</script>

<template>
	<UPaginationListItem
		:value="value"
		class="data-[selected=true]:bg-foreground hover:bg-foreground/40 data-[selected=true]:text-white"
		as-child>
		<Btn
			class="size-10 p-0"
			:variant="value === page ? 'default' : 'outline'">
			{{ digit }}
		</Btn>
	</UPaginationListItem>
</template>
